import React, { useState, useEffect } from "react";
import { bool, string, func, number } from "prop-types";
import { OnKeyDown_validInteger } from "../../../utils/validator";

const InputEjercicio = React.forwardRef((props, ref) => {
    const [state, setState] = useState({ value: "" });

    useEffect(() => {
        setState((prevState) => ({ ...prevState, value: props.value }));
    }, [props.value]);

    const handleKeyDown = (event) => {
        OnKeyDown_validInteger(event);
        if (props.maxYear) {
            const key = event.key;
            if (key >= '0' && key <= '9') {
                const target = event.target;
                const start = target.selectionStart ?? state.value.length;
                const end = target.selectionEnd ?? start;
                const newValue = state.value.substring(0, start) + key + state.value.substring(end);
                if (parseInt(newValue) > props.maxYear) {
                    event.preventDefault();
                }
            }
        }
        if (props.searchOnEnter && event.key === "Enter") {
            props.onEnter?.();
        }
    };

    const handlePaste = (event) => {
        const pastedText = event.clipboardData.getData("text");
        let numericOnly = pastedText.replace(/[^0-9]/g, "");
        if (props.maxYear) {
            numericOnly = numericOnly.substring(0, props.maxYear.toString().length);
            if (parseInt(numericOnly) > props.maxYear) {
                numericOnly = props.maxYear.toString();
            }
        }
        event.preventDefault();
        const target = event.target;
        const start = target.selectionStart;
        const end = target.selectionEnd;
        const newValue = state.value.substring(0, start) + numericOnly + state.value.substring(end);
        setState({ value: newValue });
        if (props.onChange) {
            props.onChange({ target: { name: props.name, value: newValue } });
        }
    };

    return (
        <input
            ref={ref}
            name={props.name}
            type="text"
            placeholder={props.placeholder}
            className={`input-ejercicio ${props.className}`}
            value={state.value}
            onKeyDown={handleKeyDown}
            onChange={props.onChange}
            onPaste={handlePaste}
            maxLength="4"
            disabled={props.disabled}
        />
    );
});

InputEjercicio.propTypes = {
    name: string.isRequired,
    placeholder: string,
    className: string,
    value: string,
    onChange: func,
    disabled: bool,
    onEnter: func,
    searchOnEnter: bool,
    maxYear: number,
};

InputEjercicio.defaultProps = {
    placeholder: "",
    className: "",
    value: "",
    onChange: null,
    disabled: false,
    onEnter: null,
    searchOnEnter: false,
    maxYear: null,
};

export default InputEjercicio;
